import {
  InfoModule,
  createInfoServices
} from "./chunk-FHLWH6W2.mjs";
import "./chunk-YAJQ3QCK.mjs";
export {
  InfoModule,
  createInfoServices
};
